import * as React from 'react'
import styled, { keyframes } from 'styled-components'
import { colors } from '@components/shared/colors'
import { config } from 'react-awesome-styled-grid'

type PropsType = {
  height?: string
}

export function Loading (props: PropsType): React.ReactNode {
  return (
    <LoadingContainer height={props.height}>
    </LoadingContainer>
  )
}

const fadeAnimation = keyframes`
  0% { background-color: ${colors.midnightBlue90}; }
  50% { background-color: ${colors.midnightBlueTint}; }
  100% { background-color: ${colors.midnightBlue90}; }
`

const LoadingContainer = styled.div<any>`
    display: flex;
    width: 100%;
    height: ${(props: any): string => props.height || 'auto'};
    animation: ${fadeAnimation} 4s ease-in-out infinite;
    transition: background-color 2s ease;
    border-radius: 10px;
    margin: 24px;

    ${(props: any): any => config(props).media.xs`
  `}
    ${(props: any): any => config(props).media.sm`
  `}
    ${(props: any): any => config(props).media.md`
  `}
    ${(props: any): any => config(props).media.lg`
  `}
    ${(props: any): any => config(props).media.xl`
  `}
`
